import Vue from 'vue'
import VueRouter from 'vue-router'
// import home from '@/views/Home/index.vue'

Vue.use(VueRouter)

var routes = [{
        path: '/',
        // name: 'layout',
        component: () =>
            import ('@/components/Layout/index.vue'),
        children: [{
                path: '/',
                name: 'home',
                component: () =>
                    import ('@/views/Home/index.vue'),
            },
            {
                path: '/news',
                name: 'news',
                component: () =>
                    import ('@/views/news/news.vue'),
            },
            {
                path: '/newDetail',
                name: 'newDetail',
                component: () =>
                    import ('@/views/news/newDetail.vue'),
            },
            {
                path: '/newsVol',
                name: 'newsVol',
                component: () =>
                    import ('@/views/news/newsVol.vue'),
            },
            {
                path: '/newVolDetail',
                name: 'newVolDetail',
                component: () =>
                    import ('@/views/news/newVolDetail.vue'),
            },
            {
                path: '/Organization',
                name: 'organization',
                component: () =>
                    import ('@/views/Organization/index.vue'),
            },
            // {
            //     path: '/Organization/list',
            //     name: 'OrganizationList',
            //     component: () =>
            //         import ('@/views/Organization/list.vue'),
            // },
            {
                path: '/Organization/see',
                name: 'see',
                component: () =>
                    import ('@/views/Organization/see.vue'),
            },
            {
                path: '/Rights',
                name: 'Rights',
                component: () =>
                    import ('@/views/Rights/index.vue'),
            },
            {
                path: '/regiment/list',
                name: 'regimentList',
                component: () =>
                    import ('@/views/regiment/list.vue'),
            },
            {
                path: '/regiment/index',
                name: 'regimentIndex',
                component: () =>
                    import ('@/views/regiment/index.vue'),
            },
            // 专题活动
            {
                path: '/Events',
                name: 'Events',
                component: () =>
                    import ('@/views/news/Events.vue'),
            },
            // 工作动态
            {
                path: '/workNews',
                name: 'workNews',
                component: () =>
                    import ('@/views/news/workNews.vue'),
            },
            // 党建工作
            {
                path: '/partyService',
                name: 'partyService',
                component: () =>
                    import ('@/views/news/partyService.vue'),
            },
            {
                path: '/studyList',
                name: 'studyList',
                component: () =>
                    import ('@/views/news/studyList.vue'),
            },
            // 聚焦青年
            {
                path: '/focusYouth',
                name: 'focusYouth',
                component: () =>
                    import ('@/views/news/focusYouth.vue'),
            },
            // 志愿青春
            {
                path: '/youthVolunteer',
                name: 'youthVolunteer',
                component: () =>
                    import ('@/views/news/youthVolunteer.vue'),
            },
            // 文件资料
            {
                path: '/fileInfo',
                name: 'fileInfo',
                component: () =>
                    // import ('@/views/news/fileInfo.vue'),
                    import ('@/views/news/FileInfoList.vue'),
            },
            //专题活动
            {
                path: '/listeningTestList',
                name: 'listeningTestList',
                component: () =>
                    import ('@/views/news/listeningTestList.vue'),
            },
            //青春风采
            {
                path: '/phoneBooksList',
                name: 'phoneBooksList',
                component: () =>
                    import ('@/views/news/phoneBooksList.vue'),
            },
            // 图集详情
            {
                path: '/phoneBooksDetail',
                name: 'phoneBooksDetail',
                component: () =>
                    import ('@/views/news/phoneBooksDetail.vue'),
            },
            {
                path: '/jumppage/actlist',
                name: 'actlist',
                component: () =>
                    import ('@/views/jumppage/actlist.vue'),
            },
            {
                path: '/jumppage/actlistdetail',
                name: 'actlistdetail',
                component: () =>
                    import ('@/views/jumppage/actlistdetail.vue'),
            },
            {
                path: '/jumppage/youthlist',
                name: 'youthlist',
                component: () =>
                    import ('@/views/jumppage/youthlist.vue'),
            },



        ]
    },
    {
        path: '*',
        redirect: '/'
    }
]

var router = new VueRouter({
    mode: 'history',
    routes
});
var originalPush = VueRouter.prototype.replace
VueRouter.prototype.replace = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router
